module.exports = __webpack_public_path__ + "media/images/common/external_links-def8800e97d2dcba401b10212aa0f5ca.png";